export const environment = {
  production: true,
  serverUrl: 'https://services.calibrat.com',
  googleApiKey: 'AIzaSyBMGZoRkNfav3dnrD3_dIhgQ22pyVXPXrc',
};
